function ErrorPage(props) {
  return <div>Something went wrong...</div>;
}

export default ErrorPage;
